<app-loading-page></app-loading-page>

<div id="operations-log">

  <div id="pagecontent" *ngIf="!isLoadingStaticData">

    <div id="search-fields">

      <mat-form-field subscriptSizing="dynamic">
        <mat-label>{{ 'Devices.SearchDateRange' | translate }}</mat-label>
        <mat-date-range-input [rangePicker]="picker">
          <input readonly matStartDate placeholder="Start date" [(ngModel)]="search.startDate" (ngModelChange)="searchChangeSubject.next()">
          <input readonly matEndDate placeholder="End date" [(ngModel)]="search.endDate" (ngModelChange)="searchChangeSubject.next()">
        </mat-date-range-input>
        <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-date-range-picker #picker></mat-date-range-picker>
      </mat-form-field>

      <mat-form-field class="small-mat-select-group" subscriptSizing="dynamic">
        <mat-label>{{ 'Devices.VehicleLicensePlate' | translate }}</mat-label>
        <input matInput type="text" maxlength="50" [(ngModel)]="search.licensePlate" (ngModelChange)="searchChangeSubject.next()">
      </mat-form-field>

      <mat-form-field class="small-mat-select-group" subscriptSizing="dynamic">
        <mat-label>{{ 'Devices.User' | translate }}</mat-label>
        <input matInput type="text" maxlength="50" [(ngModel)]="search.userEmail" (ngModelChange)="searchChangeSubject.next()">
      </mat-form-field>

    </div>

    <div class="table-responsive">
      <table mat-table [dataSource]="filteredHistoryEntries" [trackBy]="trackById" *ngIf="filteredHistoryEntries.length > 0"
             matSort matSortActive="DateTime" matSortDirection="desc" (matSortChange)="onMatSortChange($event)">

        <ng-container matColumnDef="DateTime">
          <th mat-header-cell mat-sort-header *matHeaderCellDef> {{ 'Devices.DeviceDateTime' | translate }} </th>
          <td mat-cell *matCellDef="let row">
            {{ row.DateTime | date:'dd/MM/yyyy HH:mm:ss' }}
          </td>
        </ng-container>

        <ng-container matColumnDef="DeviceName">
          <th mat-header-cell mat-sort-header *matHeaderCellDef> {{ 'Devices.DeviceName' | translate }} </th>
          <td mat-cell *matCellDef="let row">
            {{row.DeviceName}}
          </td>
        </ng-container>

        <ng-container matColumnDef="LicensePlate">
          <th mat-header-cell mat-sort-header *matHeaderCellDef> {{ 'Devices.VehicleLicensePlate' | translate }} </th>
          <td mat-cell *matCellDef="let row">
            {{row.LicensePlate}}
          </td>
        </ng-container>

        <ng-container matColumnDef="LockCurrentStatus">
          <th mat-header-cell mat-sort-header *matHeaderCellDef> {{ 'Devices.LockStatus' | translate }} </th>
          <td mat-cell *matCellDef="let row">
            {{row.LockCurrentStatus}}
          </td>
        </ng-container>

        <ng-container matColumnDef="DoorCurrentStatus">
          <th mat-header-cell mat-sort-header *matHeaderCellDef> {{ 'Devices.DoorStatus' | translate }} </th>
          <td mat-cell *matCellDef="let row">
            {{row.DoorCurrentStatus}}
          </td>
        </ng-container>

        <!-- <ng-container matColumnDef="RequestedValue">
          <th mat-header-cell mat-sort-header *matHeaderCellDef> {{ 'Devices.RequestedValue' | translate }} </th>
          <td mat-cell *matCellDef="let row">
            {{row.RequestedValue}}
          </td>
        </ng-container> -->

        <ng-container matColumnDef="IsManual">
          <th mat-header-cell mat-sort-header *matHeaderCellDef> {{ 'Devices.DeviceType' | translate }} </th>
          <td mat-cell *matCellDef="let row">
            {{ (row.IsManual ? ('Devices.DeviceTypeManual' | translate) : ('Devices.DeviceTypeAutomatic' | translate) ) }}
          </td>
        </ng-container>

        <ng-container matColumnDef="UserEmail">
          <th mat-header-cell mat-sort-header *matHeaderCellDef> {{ 'Devices.User' | translate }} </th>
          <td mat-cell *matCellDef="let row">
            {{row.UserEmail}}
          </td>
        </ng-container>

        <ng-container matColumnDef="DevicePosition">
          <th mat-header-cell mat-sort-header *matHeaderCellDef> {{ 'Devices.DevicePosition' | translate }} </th>
          <td mat-cell *matCellDef="let row">
            <ng-container *ngIf="row.DeviceLatitude != null">
              <button
                mat-button
                class="link-button"
                (click)="onRowClick(row)">
                {{ row.DeviceLatitude | number:'1.3-3' }}, {{ row.DeviceLongitude | number:'1.3-3' }}
              </button>
            </ng-container>
          </td>
        </ng-container>

        <ng-container matColumnDef="ClientPosition">
          <th mat-header-cell mat-sort-header *matHeaderCellDef> {{ 'Devices.ClientPosition' | translate }} </th>
          <td mat-cell *matCellDef="let row">
            <ng-container *ngIf="row.ClientLatitude != null">
              <button
                mat-button
                class="link-button"
                (click)="onRowClick(row)">
                {{ row.ClientLatitude | number:'1.3-3' }}, {{ row.ClientLongitude | number:'1.3-3' }}
              </button>
            </ng-container>
          </td>
        </ng-container>

        <ng-container matColumnDef="EventType">
          <th mat-header-cell mat-sort-header *matHeaderCellDef> {{ 'Devices.EventType' | translate }} </th>
          <td mat-cell *matCellDef="let row">
            {{ (`Devices.EventTypes.${row.EventType}` | translate) }}
          </td>
        </ng-container>

        <!-- <ng-container matColumnDef="Message">
          <th mat-header-cell mat-sort-header *matHeaderCellDef> {{ 'Devices.Message' | translate }} </th>
          <td mat-cell *matCellDef="let row">
            {{row.Message}}
          </td>
        </ng-container> -->

        <tr mat-header-row *matHeaderRowDef="['DateTime', 'DeviceName', 'LicensePlate', 'LockCurrentStatus', 'DoorCurrentStatus', 'IsManual', 'UserEmail', 'DevicePosition', 'ClientPosition', 'EventType']; sticky: true"></tr>
        <tr mat-row
          *matRowDef="let row; columns: ['DateTime', 'DeviceName', 'LicensePlate', 'LockCurrentStatus', 'DoorCurrentStatus', 'IsManual', 'UserEmail', 'DevicePosition', 'ClientPosition', 'EventType'];"
          (mouseup)="onRowMouseUp($event, row)"></tr>

      </table>
    </div>

  </div>
</div>
